import { JsonRpcClient } from '../ms_front_lib/utils/jsonrpc_client';
export { JsonRpcError, JsonRpcErrorCode } from '../ms_front_lib/utils/jsonrpc_client';
//import { Toast } from './toast';

export class Api extends JsonRpcClient {

    m_ws_url;

    constructor(iUrl) {
        super('', 5000);
        this.m_ws_url = iUrl;
        if (window?.location?.hostname == 'localhost') {
            this.m_referrer_policy = 'unsafe-url';      // Pour que le webservice puisse récupérer la query string http://localhost:8080/?EMS9996
        }

        this.m_log_base.rev ??= parseInt(gl_version);
        if (! Number.isInteger(this.m_log_base.rev)) {
            delete this.m_log_base.rev;
        }

        this.m_log_base.thread ??= (gl_config?.site_id ?? '');
    }

    async fetch(iMethod, iParams, iOptions = {}) {
        const auth_token = gl_app.authToken();
        this.setBearer(auth_token ? auth_token.id : false)
        if (!iOptions.url) {
            throw new Error("Missing url in fetch");
        } else if (iOptions.url[0] == '/') { // relative
            iOptions.url = this.m_ws_url + iOptions.url;
        }
        if (iOptions.no_wait_screen) {
            return super.fetch(iMethod, iParams, iOptions);
        }

        try {
            iParams.site_id = gl_config.site_id;
            return await super.fetch(iMethod, iParams, iOptions);
        } catch (e) {
            // console.log(e)
            // Token plus valide
            if (e.code && e.code == -32011) {
                if (localStorage.getItem('persistent_token') && window.browser_id) {
                    try {
                        const res = gl_api.loginWithPersistentToken();
                        gl_app.setAuthToken(res.auth_token);
                        return await this.fetch(iMethod, iParams, iOptions);
                    } catch (inner_err) {
                        gl_app.setAuthToken(false);
                    }
                } else {
                    gl_app.setAuthToken(false);
                }
            }
            throw new Error(e.message);
        } finally {

        }
    }

    async getProg() {
        // console.log("getProg");
        let cache = localStorage.getItem(`prog_${gl_config.site_id}`);
        // if (cache) {
        //     cache = JSON.parse(cache);
        //     if (cache.expiration_ms > Date.now()) {
        //         return cache;
        //     }
        // }
        cache = await this.fetch('get_prog', {}, { url: '/site' });
        cache.expiration_ms = Date.now() + (cache.ttl_ms ?? 60000);


        // let total = 0;
        // for (let key in localStorage) {
        // if (localStorage.hasOwnProperty(key)) {
        //     total += ((localStorage[key].length + key.length) * 2);
        // }
        // }
        // console.log((total / 1024 / 1024).toFixed(2) + " Mo utilisés");

        // !!!!! QuotaExceededError: Failed to execute 'setItem' on 'Storage': Setting the value of 'prog_EMS9997' exceeded the quota. !!!!!
        // localStorage.setItem(`prog_${gl_config.site_id}`, JSON.stringify(cache));

        // console.log('prog refreshed until ' + new Date(cache.expiration_ms));
        return cache;
    }

    async get_conf() {
        return this.fetch('get_conf', {}, { url: '/site', timeout: 60000 });
    }

    async get_conf_soldout() {
        return this.fetch('get_conf_soldout', {}, { url: '/site', timeout: 60000 });
    }

    async get_availability() {
        if (!this.cached_availability || this.cached_availability_exipration < Date.now()) {
            this.cached_availability = await this.fetch('get_availability', {}, { url: '/site', timeout: 60000 });
            this.cached_availability_exipration = Date.now() + 60000;
        }
        return this.cached_availability;
    }

    async get_super_billets() {
        // console.log("Api.js - get_super_billets");
        return this.fetch('get_super_billets', {}, { url: '/site', timeout: 60000 });
    }

    async get_website_docs(iParam) {
        return this.fetch('get_website_docs', iParam, { url: '/site', timeout: 60000 });
    }

    async getEmailInfo(iDbStage, iEmail) {
        return this.fetch('get_email_info', { email: iEmail, db_stage: iDbStage }, { url: '/account' });
    }

    async get_movies_from_dbms(iMovieID) {
        const event_country = gl_config.site && gl_config.site.lang ? gl_config.site.lang.toUpperCase() : "FR";
        const url = 'https://movies.monnaie-services.com/' + event_country + '/' + iMovieID;

        try {
            const response = await fetch(url, {
                method: "GET"
            });
            return await response.json()
        } catch (error) {
            // console.error("Erreur lors de recherche film :", error);
            throw new Error(error);
        }
    }

    async list_docs(iParam) {
        return this.fetch('list_docs', iParam, { url: '/site', timeout: 60000 });
    }

    async sendVerificationEmail(iDbStage, iEmail, iOperation, iRegistrationUrl, iTokenData) {
        return this.fetch('send_verification_email', { email: iEmail, db_stage: iDbStage, operation: iOperation, registration_url: iRegistrationUrl, token_data: iTokenData}, { url: '/account' });
    }

    // async resetUserPassword(iEmail, iToken, iPasswordHash) {
    //     return this.fetch('reset_user_password', {
    //         email: iEmail,
    //         token: iToken,
    //         password_hash: iPasswordHash
    //     }, { url: '/account' });
    // }

    async loginWithPassword(iDbStage, iEmail, iPassword, iStayConnected) {
        localStorage.removeItem('persistent_token');
        const res = this.fetch('login_with_password', {
            email: iEmail,
            db_stage: iDbStage,
            password: iPassword,
            browser_id: window.browser_id,
            stay_connected: iStayConnected
        }, { url: '/account', timeout: 60000 });

        if (res.persistent_token) {
            localStorage.setItem('persistent_token', res.persistent_token);
        }

        return res;
    }

    async loginWithPersistentToken() {
        const token = localStorage.getItem('persistent_token');
        if (!token) {
            throw new Error('No Token');
        }

        try {
            return this.fetch('login_with_persistent_token', {
                token: token,
                browser_id: window.browser_id
            }, { url: '/account', timeout: 60000 });
        } catch (err) {
            localStorage.removeItem('persistent_token');
            throw err;
        }
    }

    async loginWithToken(iDbStage, iToken) {
        return this.fetch('login_with_token', {
            token: iToken,
            db_stage: iDbStage,
            browser_id: window.browser_id
        }, { url: '/account', timeout: 60000 });
    }

    async patchUser(iParam) {
        iParam.browser_id = window.browser_id;
        // console.log(iParam)
        return this.fetch('patch_user', iParam, { url: '/account' });
    }

    async ssoLogin(iDbStage, iType, iParams, iStayConnected) {
        return this.fetch('sso_login', {
            db_stage: iDbStage,
            browser_id: window.browser_id,
            type: iType,
            params: iParams,
            stay_connected: iStayConnected,
        }, { url: '/account', timeout: 60000 });
    }

    async logout() {
        localStorage.removeItem('persistent_token');
        return this.fetch('logout', {
            browser_id: window.browser_id,
        }, {
            timeout: 1000,
            url: '/account',
        });
    }

    async refreshAuthToken(iGroupId = '') {
        return this.fetch('refresh_auth_token', {
            group_id: iGroupId,
        }, { url: '/account', timeout: 60000 });
    }

    async showError(iException) {
        return MSModal.alert(_l('Erreur'), iException.message);
    }

    async get_list_features() {
        return await $.ajax({
            type: "GET",
            url: this.m_ws_url + "/config/sessions_tags.json",
            data: "&anonymous",
            contentType: 'text/plain'
        });
    }

    async register_newsletter(iParam) {
        return this.fetch('register_newsletter', iParam, { url: '/account' });
    }

    async unsubscribe_newsletter(iParam) {
        return this.fetch('unsubscribe_newsletter', iParam, { url: '/site' });
    }

    async unsubscribe_notation_movie(iParam) {
        return this.fetch('unsubscribe_notation_movie', iParam, { url: '/site' });
    }

    async create_payment(iParam) {
        return this.fetch('create_payment', { "order_id": iParam.order_id, "psp": iParam.psp }, { url: '/ems/order_api', timeout: 60000 });
    }

    async get_banner_image(iParam) {
        return this.fetch('get_banner_image', iParam, { url: '/site', timeout: 60000 });
    }

    async get_consent(iParam) {
        return this.fetch('get_consent', iParam, { url: '/account', timeout: 60000 });
    }

    async delete_user_account(iParam){
        return this.fetch('delete_user_account', iParam, { url: '/account', timeout: 60000 });
    }

    async delete_coupon_account(iParam){
        return this.fetch('delete_coupon_account', iParam, { url: '/account', timeout: 60000 });
    }

    async get_list_avatar() {
        return await $.ajax({
            type: "GET",
            url: this.m_ws_url + "/config/account_avatar.json",
            data: "&anonymous",
            contentType: 'text/plain'
        });
    }

    async send_contact_email(iParam) {
        return this.fetch('send_contact_email', iParam, { url: '/site' });
    }

    async get_event_stars(iParam) {
        return this.fetch('get_event_stars', iParam, { url: '/ems/order_api', timeout: 60000 });
    }

    async set_event_stars(iParam) {
        return this.fetch('set_event_stars', iParam, { url: '/ems/order_api', timeout: 60000 });
    }

    async get_event_comments(iEventID) {
        return await $.ajax({
            type: "GET",
            url: "https://movies.monnaie-services.com/FR/comments/"+iEventID,
            data: "&anonymous",
            contentType: 'text/plain'
        });
    }

    // ===== API Chain (groupe) =====
    async get_events() {
        // console.log("Api.js - get_events");
        return this.fetch('get_events', {}, { url: '/site', timeout: 60000 });
    }

    async get_event_sessions(iParam) {
        return this.fetch('get_event_sessions', iParam, { url: '/site', timeout: 60000 });
    }

    // ===== API EMS =====
    async ems_check_cm(iParam) {
        // console.log("api.js - ems_check_cm", iParam)
        // Nettoyage du code de la contremarque (uniquement type 1 et 2 pour le moment)
        // On retire les "-", "_", ".", " " 
        if(iParam && iParam.type){
            switch(iParam.type){
                case 1:
                case 2:
                    iParam.scan_value = iParam.scan_value.replaceAll("-","");
                    iParam.scan_value = iParam.scan_value.replaceAll("_","");
                    iParam.scan_value = iParam.scan_value.replaceAll(".","");
                    iParam.scan_value = iParam.scan_value.replaceAll(" ","");
                    break;
                default:
                    break;
            }
        }

        var parameters_soap = {};
        parameters_soap.data = iParam;
        parameters_soap.from = "WEB";
        parameters_soap.id_borne = "";
        parameters_soap.id_util = "";
        parameters_soap.key = "";
        parameters_soap.num_cine = gl_ems_config.data_cinema.num_cine;
        parameters_soap.version_ws = '1.0';

        return this.fetch('check_cm', parameters_soap, { url: '/ems/session', timeout: 60000 });
    }

    async ems_bloque_place(iParam) {
        var parameters_soap = {};
        parameters_soap.data = iParam.data;
        parameters_soap.from = "WEB";
        parameters_soap.id_borne = "";
        parameters_soap.id_util = "";
        parameters_soap.key = "";
        parameters_soap.num_cine = gl_ems_config.data_cinema.num_cine;
        parameters_soap.version_ws = '1.0';

        return this.fetch('bloque_place', parameters_soap, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_debloque_place(iParam) {
        var parameters_soap = {};
        parameters_soap.data = iParam.data;
        parameters_soap.from = "WEB";
        parameters_soap.id_borne = "";
        parameters_soap.id_util = "";
        parameters_soap.key = "";
        parameters_soap.num_cine = gl_ems_config.data_cinema.num_cine;
        parameters_soap.version_ws = '1.0';

        return this.fetch('debloque_place', parameters_soap, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_get_order_details(iOrderId) {
        return this.fetch('get_order_details', { "order_id": iOrderId }, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_get_session_seats(iSessionID, iHallID) {
        var parameters_soap = {};
        parameters_soap.session_id = iSessionID;
        parameters_soap.hall_id = iHallID;
        parameters_soap.num_cine = gl_ems_config.data_cinema.num_cine;
        return this.fetch('get_session_seats', parameters_soap, { url: '/ems/session', timeout: 60000  });
    }

    async ems_process_order(iOrderId) {
        return this.fetch('process_order', { "order_id": iOrderId }, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_get_session_prices(iSessionID) {
        return this.fetch('get_session_prices', { session_id: iSessionID }, { url: '/ems/session', timeout: 60000 });
    }

    async ems_get_list_orders(iUID) {
        return this.fetch('get_list_orders', { "uid": iUID }, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_get_list_payments_cb_failed(iEmail) {
        return this.fetch('get_list_payments_cb_failed', { "email": iEmail }, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_get_info_refund(iOrderId, iEmail) {
        return this.fetch('get_info_refund', { "order_id": iOrderId, "email": iEmail }, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_do_refund(iParam) {
        return this.fetch('do_refund', iParam, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_transform_points_kdo(iParam) {
        return this.fetch('transform_points_kdo', iParam, { url: '/ems/order_api', timeout: 60000 });
    }

    async ems_get_list_user_vouchers(iParam) {
        return this.fetch('get_list_user_vouchers', iParam, { url: '/account', timeout: 60000 });
    }
}

